import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'eu-west-1_OoaJjunMO',
  ClientId: '7668og46tiben8g5gt0bcele3e'
};

export default new CognitoUserPool(poolData);
